module.exports = __webpack_public_path__ + "static/media/base-apparel.5feff7a7.jpg";